import { useTheme } from '@mui/material';
export const useMobileHeaderStyles = () => {
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    return {
        MobileHeaderContainer: {
            display: 'flex',
            flexDirection: 'column',
            padding: '8px 16px',
            minHeight: 48,
            alignItems: 'flex-start',
            width: '100%',
            gap: '6px',
            background: isLightMode ? theme.palette.primary.main : theme.palette.primary.light
        },
        NavInner: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        SearchBarContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            padding: 0,
            alignSelf: 'stretch'
        },
        NavTitleContainer: {
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center'
        },
        markAsReadButtonStyles: {
            color: isLightMode ? theme.palette.primary.contrastText : theme.palette.grey[900]
        }
    };
};
export default useMobileHeaderStyles;
